import { configureStore} from '@reduxjs/toolkit';
import authenticationReducer from '../auth/AuthenticationSlice';
import createSagaMiddleware from '@redux-saga/core';
import rootSaga from '../core/RootSaga';

const sagaMiddleWare = createSagaMiddleware();

export const store = configureStore({
  middleware : (getDefaultMiddleware) => getDefaultMiddleware().concat(sagaMiddleWare),
  reducer: {
    auth: authenticationReducer,
  },
});

sagaMiddleWare.run(rootSaga);
